/* eslint-disable */
// @ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Link } from '../core';
import { updateUser } from '../../actions/UserActions';
import { getCurrentTimeInUTC } from '../../../main/support/dateUtils';
import { LEGAL_TERMS_CONDITIONS_LINK } from '../../support/gdprConstants';
import type { HistoryType } from '../../router/withRouter';
type Props = {
  updateUser: (app: Record<string, any>) => any;
  history: HistoryType;
};
type State = {
  hide: boolean;
};

class CookieBanner extends React.Component<Props, State> {
  state = {
    hide: false,
  };

  unlisten = () => {};

  componentDidMount = () => {
    const pathname = window.location.pathname;
    this.unlisten = this.props.history.listen((location) => {
      if (location.pathname !== pathname && pathname !== '/login') {
        this.acceptCookies();
      }
    });
  };

  componentWillUnmount = () => {
    this.unlisten();
  };

  acceptCookies = () => {
    this.props
      .updateUser({
        cookie_accept_date: getCurrentTimeInUTC(),
      })
      .then(() => {
        this.setState({
          hide: true,
        });
        window.location.reload();
      });
  };

  declineCookies = () => {
    this.props
      .updateUser({
        cookie_decline_date: getCurrentTimeInUTC(),
      })
      .then(() => {
        this.unlisten();
        this.setState({
          hide: true,
        });
      });
  };

  render() {
    if (this.state.hide) {
      return null;
    }

    return (
      <div className="cookie-banner" data-testid="cookie-banner">
        <div className="h_px-40 h_py-10">
          <span className="h_fw-600">This website uses cookies.</span>{' '}
          <span>By continuing to use our website, you are agreeing to the use of our cookies and web beacons.</span>{' '}
          <Link testid="cookie-banner_learn-more" href={LEGAL_TERMS_CONDITIONS_LINK}>
            Learn More
          </Link>
          .
        </div>
        <div>
          <Button
            type="secondary"
            size="medium"
            testid="cookie-banner_decline"
            className="h_mend-10"
            onClick={this.declineCookies}
          >
            Decline
          </Button>
          <Button size="medium" testid="cookie-banner_accept" onClick={this.acceptCookies}>
            Accept
          </Button>
        </div>
      </div>
    );
  }
}

const mapDispatchProps = (dispatch) => ({
  updateUser: (user) => dispatch(updateUser(user)),
});

export default connect(null, mapDispatchProps)(withRouter(CookieBanner));
